import { Fragment, useMemo } from "react";
import { Outlet, useLocation } from "react-router";
import Navbar from "./Navbar";
import Footer from "./Footer";
import NotFoundPage from "@/pages/NotFoundPage";
import { metaFor, notFound } from "@/content/site";
import { useClientSideLinks, useWebflowPage } from "@/lib/webflow";

export default function Layout() {
  const { pathname } = useLocation();
  const meta = useMemo(() => metaFor(pathname), [pathname]);
  useClientSideLinks();
  useWebflowPage(meta, pathname);

  // Keyed by path so every navigation mounts fresh markup with the initial inline
  // styles IX2 animates from — the same as a full page load on Webflow.
  return (
    <Fragment key={pathname}>
      {meta === notFound ? (
        <NotFoundPage />
      ) : (
        <>
          <Navbar />
          <Outlet />
          <Footer />
        </>
      )}
    </Fragment>
  );
}
